import React from 'react'
import { createStyles, makeStyles, Select, Box, useMediaQuery, useTheme, MenuItem } from '@material-ui/core'
import { useTranslation } from 'react-i18next'
import { ReactComponent as DownArrowIcon } from 'src/mobile/assets/icons/arrow-down-fill.svg'
import { LOCATIONS } from 'src/utils/constant'
import { translateRegion } from 'src/utils'

const useStyles = makeStyles((theme) =>
  createStyles({
    select: {
      color: '#fff',
      fontSize: theme.typography.body1.fontSize,
      fontWeight: '700',
      background: 'primary.main',
      '&$select': {
        height: '100%',
        width: '210px',
        display: 'flex',
        alignItems: 'center',
        padding: theme.spacing(0, 2),
        paddingRight: theme.spacing(0),
        [theme.breakpoints.down('xs')]: {
          width: '185px',
        },
      },
      [theme.breakpoints.down('xs')]: {
        padding: theme.spacing(0, 2),
      },
    },
    arrowIcon: {
      flexShrink: 0,
      width: theme.spacing(1.5),
      height: theme.spacing(1.5),
      marginRight: 3,
      '& path': {
        fill: theme.palette.grey[100],
      },
    },
  }),
)

const FilterBar = ({
  onChange,
  defaults,
  options = LOCATIONS.map((region) => {
    return {
      label: region?.label,
      value: region?.value,
    }
  }),
}) => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('xs'))
  const classes = useStyles()
  const { t } = useTranslation()
  // const _handleChange = (e) => onChange?.({ value: e.target.value || '' })

  return (
    <Box
      alignItems="enter"
      display="flex"
      height={56}
      bgcolor="#1F2937"
      borderRadius={5}
      justifyContent="center"
    >
      <Select
        classes={{
          root: classes.select,
        }}
        defaultValue=""
        onChange={onChange}
        IconComponent={() => <DownArrowIcon className={classes.arrowIcon} />}
        displayEmpty
        native={isMobile}
        disableUnderline
      >
        {isMobile
          ? options.map((item, index) => (
              <option key={item.value + index} value={item.value}>
                {t(translateRegion(item.label))}
              </option>
            ))
          : options.map((item, index) => (
              <MenuItem key={item.value + index} value={item.value}>
                {t(translateRegion(item.label))}
              </MenuItem>
            ))}
      </Select>
    </Box>
  )
}

export default FilterBar
